import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { Col, Container, Row } from "reactstrap";
import moment from "moment";
import { Card, CardBody } from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import {getStaffDetailRequest} from "store/Staff/actions";

class StaffDetails extends Component {
  componentDidMount() {
    const {
      match: { params }, 
    
      getStaffDetailRequest, 
    } = this.props;
    console.log("params", params);
    console.log("params.email",params.email);
  
    
      getStaffDetailRequest(params.id); 
  }

  render() {
 const {Staff} = this.props;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Staffs" breadcrumbItem="Staff Details" />
            {this.props.loading && (
              <div className="text-center " style={{
                
              }}>
                <i className="bx bx-loader bx-spin align-middle me-2" style={{fontSize:48,color:'#2A3042'}}/>
              </div>
            )}
            {!isEmpty(Staff) && !this.props.loading && (
              <>
                
                  <Col lg="12" className="mt-0" >
                   
                    {/* <PathologistDetails pathologist={PathologistDetail} /> */}
                    <Row>
                        <Col lg="12">
                        
                        <Card>
                            <CardBody>
                            <div>
                            <div className="flex-grow-1 overflow-hidden">
                            
                            <h5 className="text-truncate font-size-24">
                                {this.props.Staff.name}
                            </h5>
                            <hr
                        style={{
                        background: 'black',
                        color: 'black',
                        borderColor: 'black',
                        height: '3px',
                        }}
                    />
                            
                            </div>
                        
                    
                        <h5 className="font-size-15 mt-4">Email</h5>
                        <p className="text-muted">
                        <i className='bx bx-envelope bx-tada'></i>
                        &nbsp;  &nbsp;  {this.props.Staff.email}
                        </p>
                    
                    
                    
                        <h5 className="font-size-15 mt-4">Contact Number</h5>
                        <p className="text-muted">
                        <i className='bx bxs-phone-call bx-tada' ></i>
                        &nbsp; {this.props.Staff.contact_number}
                        </p>
                        
                            <h5 className="font-size-15 mt-4">CNIC</h5>
                        <p className="text-muted">
                        <i className='bx bx-id-card bx-tada' ></i>
                        &nbsp; &nbsp;{this.props.Staff.CNIC}
                        </p>

                        
                        <h5 className="font-size-15 mt-4">Date Joined</h5>
                        <p className="text-muted">
                        <i className='bx bx-calendar bx-tada' ></i>
                        &nbsp; &nbsp; 
                        {/* {new Date(this.props.pathologist.date_joined).toDateString()} */}
                            {moment(this.props.Staff.date_joined).format("YYYY-MM-DD")}
                            {/* {moment(this.props.pathologist.date_joined).format("LL")} */}
                        
                        </p>
                            </div>
                            </CardBody>
                        </Card>
                        </Col>
                        {/* <Col lg="3">
                        <Card>
                        <CardBody>
                        <div className="d-flex flex-wrap">
                            <div>
                                <h3 className="font-size-22"> Registered Staffs</h3>
                            </div>
                                <div>
                                <p className="text-muted mb-1">Total Staffs Registered</p>
                                <h2 className="mb-3 text-center">14</h2>
                                <div className="mx-auto text-center">
                                <i className='bx bxs-user-detail bx-lg' ></i>
                                
                                </div>
                                </div>
                                </div>
                                </CardBody>
                                </Card>
                                
                                </Col> */}
                                
                        </Row>
                  </Col>

                  
             

            
              </>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

StaffDetails.propTypes = {
loading: PropTypes.bool,
  match: PropTypes.object,
    // homesampler: PropTypes.object,
  Staff: PropTypes.any,
  Staff: PropTypes.object,

getStaffDetailRequest: PropTypes.func,
onEditStaff: PropTypes.func,
onDeleteStaff: PropTypes.func,
};

const mapStateToProps = state => ({
    
//   Staff: state.EmployeeReducer.homesampler,
  Staff: state.StaffReducer.Staff,
//   homesampler: state.EmployeeReducer.homesampler,
  loading: state.StaffReducer.isLoading,
});

const mapDispatchToProps = dispatch => ({

getStaffDetailRequest: email => dispatch(getStaffDetailRequest(email)),

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StaffDetails));